<template>
  <div class="skeleton-tenders">
    <div v-for="i in itemCount" :key="i" class="frame-parent skeleton-item">
      <!-- Left Section -->
      <div class="renhold-parent">
        <Skeleton shape="circle" size="40px" class="renhold-icon" />
        <div class="instance-wrapper">
          <div class="innendrs-renhold-parent">
            <Skeleton width="120px" height="16px" class="mb-1" />
            <Skeleton width="160px" height="14px" class="mb-1" />
            <Skeleton width="140px" height="12px" />
          </div>
        </div>
      </div>

      <!-- Right Section -->
      <div class="listcolumnsrow-parent">
        <div class="listcolumnsrow">
          <div class="listcolumn">
            <div class="listcolumn-child" />
            <div class="detaljer-parent">
              <Skeleton shape="circle" size="24px" />
              <div class="krmnd-parent">
                <Skeleton width="80px" height="12px" class="mb-1" />
                <Skeleton width="100px" height="12px" />
              </div>
            </div>
          </div>
          <div class="listcolumn">
            <div class="listcolumn-child" />
            <div class="detaljer-parent">
              <Skeleton shape="circle" size="24px" />
              <div class="krmnd-parent">
                <Skeleton width="80px" height="12px" class="mb-1" />
                <Skeleton width="100px" height="12px" />
              </div>
            </div>
          </div>
          <div class="listcolumn2">
            <div class="listcolumn-child" />
            <div class="detaljer-parent">
              <Skeleton shape="circle" size="24px" />
              <div class="krmnd-parent">
                <Skeleton width="100px" height="12px" class="mb-1" />
                <Skeleton width="80px" height="12px" />
              </div>
            </div>
          </div>
        </div>
        <Skeleton shape="circle" size="24px" />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import Skeleton from "primevue/skeleton";

defineProps({
  itemCount: {
    type: Number,
    default: 3,
  },
});
</script>

<style lang="scss" scoped>
.skeleton-tenders {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.skeleton-item {
  width: 100%;
  position: relative;
  border-radius: 8px;
  background-color: #fff;
  height: 72px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 0 16px;
  box-sizing: border-box;
}

.renhold-parent {
  flex: 1;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
}

.instance-wrapper {
  flex: 1;
  display: flex;
  flex-direction: row;
  align-items: center;
  min-width: 170px;
}

.innendrs-renhold-parent {
  height: 80px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  gap: 2px;
}

.listcolumnsrow-parent {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 16px;
}

.listcolumnsrow {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: 8px;
}

.listcolumn,
.listcolumn2 {
  width: 172px;
  border-radius: 4px;
  height: 48px;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0 8px 0 0;
  box-sizing: border-box;
  gap: 7px;
}

.listcolumn2 {
  background-color: #f4f4f4;
}

.listcolumn-child {
  width: 1px;
  height: 32px;
}

.detaljer-parent {
  flex: 1;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
}

.krmnd-parent {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
}
</style>
